export const trackingEvents = {
  PAGE: { VIEWED: 'conduct_reviews.detail.viewed' },
  BACK: { CLICKED: 'conduct_reviews.detail_back.clicked' },
  SAVE: { CLICKED: 'conduct_reviews.detail_save.clicked' },
}
